// ─── DATE CONSTANTS ───────────────────────────────────────────────────────────
// Shared, app-wide day/month label arrays (Sunday-first, matching the default
// calendar layout). NOTE: some views (e.g. a Monday-first week strip) define
// their own local DAYS_SHORT — those intentionally shadow this export.
export const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
export const DAYS_SHORT = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
export const DAYS_FULL = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
